import React from "react";
import TexteUI from "./TexteUI";
import ImageUI from "./ImageUI";
import MockupUI from "./MockupUI";
import StoryTexteUI from "./StoryTexteUI";
import StoryItwUI from "./StoryItwUI";
import PlancheContactUI from "./PlancheContactUI";
import ProductUI from "./ProductUI";
import TiroirUI from "./TiroirUI";

const Modules = ({ input }) => {
  // console.log(input);
  // const scroller = useRef();
  // useEffect(() => {
  //   scroller.current.addEventListener("wheel", _onWheel);

  //   return () => {
  //     // console.log(scroller);
  //     if (scroller.current)
  //       scroller.current.removeEventListener("wheel", _onWheel);
  //   };
  // }, []);

  // const _onWheel = e => {
  //   // if (isMobile) return;

  //   const rawData = e.wheelDelta;
  //   const mouseX = Math.floor(rawData);
  //   // console.log(mouseX, scroller)
  //   scroller.current.scrollLeft -= mouseX;

  //   e.preventDefault();
  // };

  const _renderModules = () => {
    const _modules = input.map((module, i) => {
      // console.log(module);
      switch (module._type) {
        case "tiroirUI":
          return <TiroirUI key={i} input={module} />;
        case "texteUI":
          return <TexteUI key={i} input={module} />;
        case "imageUI":
          return <ImageUI key={i} input={module} />;
        case "mockupUI":
          return <MockupUI key={i} input={module} />;
        case "plancheContactUI":
          return <PlancheContactUI key={i} input={module} />;
        case "storyTexteUI":
          return <StoryTexteUI key={i} input={module} />;
        case "storyItwUI":
          return <StoryItwUI key={i} input={module} />;
        case "productUI":
          return <ProductUI key={i} input={module} />;
        default:
          return null;
      }
    });
    return _modules;
  };

  return <>{_renderModules()}</>;
};

export default Modules;
